import { useContext } from "react";
import ICatalog_Item from "@models/ICatalog_Item";
import CatalogItemService from "@services/CatalogItemService";
import SupplierContext from "@contexts/SupplierContext";
import IWarehouse_Catalog_Items_Map from "@models/IWarehouse_Catalog_Items_Map";
import { FormattedNumber } from "react-intl";
import UserService from "@services/UserService";
import UserContext from "@contexts/UserContext";
import IWarehouse from "@models/IWarehouse";

type Props = {
    catalogItem?: ICatalog_Item;
    mapItem?: IWarehouse_Catalog_Items_Map;
    shippingWarehouse?: IWarehouse;
    showColoredQoh?: boolean;
};

export const QtyOnHandValue = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const showInventoryDetails = UserService.showInventoryDetails(supplierModel, userModel);

    let qtyOnHand = props.catalogItem?.qty_on_hand || 0;

    if (props.mapItem || props.shippingWarehouse) {
        qtyOnHand = props.mapItem?.qty_on_hand || 0;
    }

    if (props.catalogItem?.Material_Catalog_Item_Maps?.length) {
        qtyOnHand = CatalogItemService.getItemQtyOnHandBasedOnMaterials(props.catalogItem);
    }

    const getQohIcon = () => {
        const minQtyOnHand = props.catalogItem?.min_qty_on_hand || 0;
        const maxQtyOnHand = props.catalogItem?.max_qty_on_hand || 0;

        if (!props.catalogItem?.is_ordered_on_demand) {
            if (qtyOnHand > maxQtyOnHand) {
                return <i className={"fad fa-battery-full text-success fa-2x"} />;
            } else if (qtyOnHand >= minQtyOnHand && qtyOnHand <= maxQtyOnHand) {
                return <i className={"fad fa-battery-half text-warning fa-2x"} />;
            } else if (qtyOnHand > 0 && qtyOnHand < minQtyOnHand) {
                return <i className={"fad fa-battery-low faded-orange fa-2x"} />;
            } else {
                return <i className={"fad fa-battery-empty text-danger fa-2x"} />;
            }
        }
    };

    const getQohValue = () => {
        const minQtyOnHand = props.catalogItem?.min_qty_on_hand || 0;
        const maxQtyOnHand = props.catalogItem?.max_qty_on_hand || 0;

        let className = "px-3 rounded-pill py-1 ";

        if (qtyOnHand > maxQtyOnHand) {
            className += "bg-success";
        } else if (qtyOnHand >= minQtyOnHand && qtyOnHand <= maxQtyOnHand && qtyOnHand > 0) {
            className += "bg-warning";
        } else if (qtyOnHand > 0 && qtyOnHand < minQtyOnHand) {
            className += "bg-danger";
        } else {
            className += "bg-danger";
        }

        if (!props.showColoredQoh) {
            className = "";
        }

        return (
            <span className={className}>
                <FormattedNumber value={qtyOnHand} minimumFractionDigits={supplierModel.qty_precision} />
            </span>
        );
    };

    return (
        <div className={"QtyOnHandValue"}>
            {supplierModel.qoh_as_icon ? getQohIcon() : showInventoryDetails ? getQohValue() : qtyOnHand > 0 ? "Y" : "N"}
        </div>
    );
};
